import { useEffect, useRef } from "react";
import StateService from "../../services/StateService";

// If the app launches on the empty state, open the guide for the user once.
// We pull the state from StateService because the empty state renders before this
// EPG tree mounts, so a push from it would race the mount.
export default function useAutoOpenGuide({ epgReady, isOpen, openEPG }) {
    const initialOpenDoneRef = useRef(false);

    useEffect(() => {
        // Wait for events to load (so we never open an empty guide), then decide once.
        if (initialOpenDoneRef.current || !epgReady) return;
        initialOpenDoneRef.current = true;

        // The user already opened it during launch, don't open it again.
        if (isOpen) return;

        if (StateService.currentStateDef?.name === "empty_state") {
            openEPG();
        }
    }, [epgReady, isOpen, openEPG]);
}
